import { Routes, Route, Navigate } from "react-router-dom";
import AppContainer from "./pages/AppContainer";
import RegisterPage from "./pages/auth/RegisterPage";
import AuthContainer from "./pages/AuthContainer";
import BalootOTPConfirmPage from "./pages/auth/BalootOTPConfirmPage";
import SetPasswordContainer from "./pages/auth/SetPasswordContainer";
import SetPasswordPage from "./pages/auth/SetPasswordPage";
import ConfirmPasswordPage from "./pages/auth/ConfirmPasswordPage";
import NationalIdPage from "./pages/auth/NationalIdPage";
import SejamOTPConfirmPage from "./pages/auth/SejamOTPConfirmPage";
import PersonalInfoContainer from "./pages/auth/PersonalInfoContainer";
import FirstNamePage from "./pages/auth/FirstNamePage";
import LastNamePage from "./pages/auth/LastNamePage";
import SejamStatusPage from "./pages/auth/SejamStatusPage";
import LoginPage from "./pages/auth/LoginPage";
import LockPage from "./pages/auth/LockPage";
import TokenNeeded from "./api/utils/TokenNeeded";
import { useNavigate } from "react-router-dom";
import AppPagesContainer from "./pages/app/AppPagesContainer";
import AppNavigationContainer from "./pages/app/AppNavigationContainer";
import HomePage from "./pages/app/HomePage";
import WalletPage from "./pages/app/WalletPage";
import DirectDebitContainer from "./pages/app/direct-debit/DirectDebitContainer";
import DirectDebitMainPage from "./pages/app/direct-debit/DirectDebitMainPage";
import DirectDebitSetBankPage from "./pages/app/direct-debit/DirectDebitSetBankPage";
import DirectDebitSetAmountPage from "./pages/app/direct-debit/DirectDebitSetAmountPage";
import DirectDebitSetPeriodPage from "./pages/app/direct-debit/DirectDebitSetPeriodPage";
import AutoInvestmentContainer from "./pages/app/auto-investment/AutoInvestmentContainer";
import AutoInvestmentAddOrRemovePage from "./pages/app/auto-investment/AutoInvestmentAddOrRemovePage";
import AutoInvestmentStatusPage from "./pages/app/auto-investment/AutoInvestmentStatusPage";
import ReceiptPage from "./pages/app/ReceiptPage";
import AssetsPage from "./pages/app/AssetsPage";
import InvestmentPage from "./pages/app/InvestmentPage";
import FinancialAssetPage from "./pages/app/FinancialAssetPage";
import FinancialAssetBuyPage from "./pages/app/FinancialAssetBuyPage";
import FinancialAssetSellPage from "./pages/app/FinancialAssetSellPage";
import FinancialAssetSellOTPPage from "./pages/app/FinancialAssetSellOTPPage";
import CashoutPage from "./pages/app/CashoutPage";
import CashoutSuccessPage from "./pages/app/CashoutSuccessPage";
import ProfilePage from "./pages/app/ProfilePage";
import ProfileSettingPage from "./pages/app/profile/ProfileSettingPage";
import ProfileAccountPage from "./pages/app/profile/ProfileAccountPage";
import ProfileSettingContractPage from "./pages/app/profile/ProfileSettingContractPage";
import ProfileSettingSejamContainer from "./pages/app/profile/sejam/ProfileSettingSejamContainer";
import ProfileSettingSejamStatusPage from "./pages/app/profile/sejam/ProfileSettingSejamStatusPage";
import ProfileSettingSejamOtp from "./pages/app/profile/sejam/ProfileSettingSejamOtp";
import ProfileSettingChangePasswordPage from "./pages/app/profile/ProfileSettingChangePasswordPage";
import ProfileSettingPersonalPage from "./pages/app/profile/ProfileSettingPersonalPage";
import ProfileSettingPersonalChangeMobilePage from "./pages/app/profile/ProfileSettingPersonalChangeMobilePage";
import ProfileSettingPersonalChangeMobileOTPPage from "./pages/app/profile/ProfileSettingPersonalChangeMobileOTPPage";
import ProfileSupportPage from "./pages/app/profile/ProfileSupportPage";
import ProfileGiftPage from "./pages/app/profile/ProfileGiftPage";
import ProfileReferralPage from "./pages/app/profile/ProfileReferralPage";
import MessagesPage from "./pages/app/MessagesPage";
import FinancialAssetSellSuccessPage from "./pages/app/FinancialAssetSellSuccessPage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ForgotPasswordOTPPage from "./pages/auth/ForgotPasswordOTPPage";
import AutoInvestmentActivatePage from "./pages/app/auto-investment/AutoInvestmentActivatePage";
import ReferralPage from "./pages/auth/ReferralPage";
import HistoryReferralPage from "./pages/app/profile/HistoryReferralPage";

function App() {
  const navigate = useNavigate();
  TokenNeeded.navigate = navigate;
  return (
    <Routes>
      <Route path="/" element={<AppContainer />}>
        <Route path="auth" element={<AuthContainer />}>
          <Route path="referral" element={<ReferralPage />} />
          <Route path="lock" element={<LockPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="baloot-otp-confirm" element={<BalootOTPConfirmPage />} />
          <Route
            path="forgot-password/otp"
            element={<ForgotPasswordOTPPage />}
          />
          <Route path="forgot-password" element={<ForgotPasswordPage />} />
          <Route path="set-password" element={<SetPasswordContainer />}>
            <Route path="set" element={<SetPasswordPage />} />
            <Route path="confirm" element={<ConfirmPasswordPage />} />
          </Route>
          <Route path="national-id" element={<NationalIdPage />} />
          <Route path="sejam-otp-confirm" element={<SejamOTPConfirmPage />} />
          <Route path="personal-info" element={<PersonalInfoContainer />}>
            <Route path="first-name" element={<FirstNamePage />} />
            <Route path="last-name" element={<LastNamePage />} />
          </Route>
          <Route path="sejam-status" element={<SejamStatusPage />} />
        </Route>
        <Route path="app" element={<AppPagesContainer />}>
          <Route index element={<Navigate replace to="navigation/home" />} />
          <Route path="navigation" element={<AppNavigationContainer />}>
            <Route path="home" element={<HomePage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="assets" element={<AssetsPage />} />
            <Route path="investment" element={<InvestmentPage />} />
          </Route>
          <Route
            path="financial-asset/:assetId"
            element={<FinancialAssetPage />}
          />
          <Route
            path="financial-asset/:assetId/buy"
            element={<FinancialAssetBuyPage />}
          />
          <Route
            path="financial-asset/:assetId/sell"
            element={<FinancialAssetSellPage />}
          />
          <Route
            path="financial-asset/:assetId/sell/otp"
            element={<FinancialAssetSellOTPPage />}
          />
          <Route
            path="financial-asset/:assetId/sell/success"
            element={<FinancialAssetSellSuccessPage />}
          />
          <Route path="wallet" element={<WalletPage />} />
          <Route path="cashout" element={<CashoutPage />} />
          <Route path="cashout/success" element={<CashoutSuccessPage />} />
          <Route path="profile/gift" element={<ProfileGiftPage />} />
          <Route path="profile/support" element={<ProfileSupportPage />} />
          <Route path="profile/setting" element={<ProfileSettingPage />} />
          <Route path="profile/account" element={<ProfileAccountPage />} />
          <Route path="profile/referral" element={<ProfileReferralPage />} />
          <Route
            path="profile/referral-history/:campaignId"
            element={<HistoryReferralPage />}
          />

          <Route
            path="profile/setting/contract"
            element={<ProfileSettingContractPage />}
          />
          <Route
            path="profile/setting/change-password"
            element={<ProfileSettingChangePasswordPage />}
          />
          <Route
            path="profile/setting/personal"
            element={<ProfileSettingPersonalPage />}
          />
          <Route
            path="profile/setting/personal/change-mobile"
            element={<ProfileSettingPersonalChangeMobilePage />}
          />
          <Route
            path="profile/setting/personal/change-mobile/otp"
            element={<ProfileSettingPersonalChangeMobileOTPPage />}
          />

          <Route
            path="profile/setting/sejam"
            element={<ProfileSettingSejamContainer />}
          >
            <Route index element={<Navigate replace to="status" />} />
            <Route path="status" element={<ProfileSettingSejamStatusPage />} />
            <Route path="otp" element={<ProfileSettingSejamOtp />} />
          </Route>
          <Route path="direct-debit" element={<DirectDebitContainer />}>
            <Route index element={<DirectDebitMainPage />} />
            <Route path="set-bank" element={<DirectDebitSetBankPage />} />
            <Route path="set-amount" element={<DirectDebitSetAmountPage />} />
            <Route path="set-period" element={<DirectDebitSetPeriodPage />} />
          </Route>
          <Route path="receipt" element={<ReceiptPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="auto-investment" element={<AutoInvestmentContainer />}>
            <Route index element={<AutoInvestmentActivatePage />} />
            <Route
              path="add-or-remove"
              element={<AutoInvestmentAddOrRemovePage />}
            />
            <Route path="status" element={<AutoInvestmentStatusPage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
